import React from "react";
import Layout from "../components/layout";
import Converter from "../components/apps/converter/converter";

const Hexbindec = () =>{
    return(
        <Layout>
            <Converter />
        </Layout>
    );
} 
export default Hexbindec;